import { Link } from "@tanstack/react-router"

export function SettingsNav() {
  return (
    <nav
      aria-label="Settings sections"
      className="tabs mb-6 flex flex-wrap gap-6 border-b border-border"
    >
      <Link
        to="/settings/schedules"
        activeOptions={{ exact: true, includeSearch: false }}
        activeProps={{ "aria-current": "page" }}
        className="tab relative inline-flex min-h-10 items-center gap-2 px-1 pb-3 text-[13px] font-medium text-muted-foreground outline-none transition-colors after:absolute after:inset-x-0 after:bottom-0 after:h-0.5 after:scale-x-0 after:rounded-full after:bg-foreground after:transition-transform hover:text-foreground focus-visible:ring-2 focus-visible:ring-ring data-[status=active]:text-foreground data-[status=active]:after:scale-x-100"
      >
        Schedules
      </Link>

      <Link
        to="/settings/listing-automation"
        activeOptions={{ exact: true }}
        activeProps={{ "aria-current": "page" }}
        className="tab relative inline-flex min-h-10 items-center px-1 pb-3 text-[13px] font-medium text-muted-foreground outline-none hover:text-foreground focus-visible:ring-2 focus-visible:ring-ring data-[status=active]:text-foreground data-[status=active]:border-b-2 data-[status=active]:border-foreground"
      >
        Listing automation
      </Link>

      <Link
        to="/settings/value-recovery"
        activeOptions={{ exact: true }}
        activeProps={{ "aria-current": "page" }}
        className="tab relative inline-flex min-h-10 items-center px-1 pb-3 text-[13px] font-medium text-muted-foreground outline-none hover:text-foreground focus-visible:ring-2 focus-visible:ring-ring data-[status=active]:text-foreground data-[status=active]:border-b-2 data-[status=active]:border-foreground"
      >
        Value recovery
      </Link>
    </nav>
  )
}
